var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.predefinedValue === "irrelevant"
    ? _c("span", [_vm._v("Übereinstimmung")])
    : _vm.predefinedValue === "none"
    ? _c("span", [_vm._v("Keine")])
    : _vm.predefinedValue === "wanted"
    ? _c("span", [_vm._v("Erwünscht")])
    : _vm.predefinedValue === "unwanted"
    ? _c("span", [_vm._v("Nicht erwünscht")])
    : _vm.predefinedValue === "noneMatching"
    ? _c("span", [_vm._v("Keine Übereinstimmung")])
    : _vm.predefinedValue === "yes"
    ? _c("span", [_vm._v("Übereinstimmung")])
    : _vm.predefinedValue === "no"
    ? _c("span", [_vm._v("Keine Übereinstimmung")])
    : _vm.predefinedValue === "noneNecessary"
    ? _c("span", [_vm._v("Keine nötig")])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }